import { IBusinessExemptInspectionsViewModel } from "../mainMenu/mainMenu";

export interface IBusinessSiteVisitViewModel {
  // canAddInitialSiteVisit: boolean;
  canAddPostRemediationSiteVisit: boolean;
  businessId: number;

  businessName: string;
  businessAddress: string;
  businessCity: string;
  businessZip: string;
  businessExempt: boolean;

  lastUpdatedBy: string;
  lastUpdatedDate: Date;

  initialSiteVisits: IBusinessInitialSiteVisitViewModel[];
  followupSiteVisits: IBusinessFollowUpSiteVisitViewModel[];
  postRemediationPlanSiteVisits: IBusinessPostRemediationPlanSiteVisitViewModel[];
  inspectionSiteVisits: IBusinessInspectionSiteVisitViewModel[];
  exemptInspections: IBusinessExemptInspectionsViewModel[];
}

export interface IBusinessInitialSiteVisitViewModel {
  id: number;
  complaintId: number;
  origComplaintDate: string;
  subsequentComplaintDate: string;
  visitDate: string;

  allowEditing: boolean;
  notes: string;
  visitConducted: number;
  visitConductedReason: number;
  violationFound: number;
}

export interface IBusinessFollowUpSiteVisitViewModel{
  id: number;
  complaintId: number;
  visitDate: string;
  requiredImplementationDate: string;
  requiredVisitDate: string;
  actualCompletionDate: string;
  violationNotes: string;
  correctionRequiredNotes: string;
  remediationResult: string;
  followupDate: string;
  followupConducted: number;
  followupDateConducted: number;
  comments: string;
  allowEditing: boolean;
}

export interface IBusinessPostRemediationPlanSiteVisitViewModel {
  id: number;
  complaintId: number;
  followupVisitId: number;
  comments: string;
  postRemediationConducted: number;
  postRemediationDate: string;
  postRemediationResult: string;
  allowEditing: boolean;
}

export interface IBusinessInspectionSiteVisitViewModel {
  id: number;
  complaintId: number;
  visitDate: string;
  requiredImplementationDate: string;
  requiredVisitDate: string;
  actualCompletionDate: string;
  violationNotes: string;
  correctionRequiredNotes: string;
  remediationResult: string;
  followupDate: string;
  followupConducted: number;
  followupDateConducted: number;
  comments: string;
  allowEditing: boolean;
}






